import { useAuthActions } from '@convex-dev/auth/react';

export const ConvexErrorFallback = ({ error }: { error: Error }) => {
  const { signOut } = useAuthActions();

  const handleClearSession = async () => {
    try {
      await signOut();
      window.location.reload();
    } catch (e) {
      console.error('Failed to clear session:', e);
      window.location.reload();
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto mt-10 bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-semibold text-red-600 mb-4">
        Connection Issue
      </h2>
      <p className="text-gray-700 mb-4">
        We're having trouble connecting to the server. This might be because the
        Convex backend is not running or there's a session issue.
      </p>
      <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-4">
        <p className="text-yellow-700 text-sm">
          <span className="font-medium">Error details:</span> {error.message}
        </p>
      </div>
      <div className="mt-6 space-y-3">
        <button
          onClick={() => window.location.reload()}
          className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 transition-colors"
        >
          Refresh Page
        </button>
        <button
          onClick={() => void handleClearSession()}
          className="w-full bg-orange-500 text-white py-2 px-4 rounded hover:bg-orange-600 transition-colors"
        >
          Clear Session & Refresh
        </button>
        <p className="text-center text-sm text-gray-500">
          If the problem persists, please try again later or contact support.
        </p>
      </div>
    </div>
  );
};
